// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__A+ji+","tabList":"Tabs_tabList__V2TTg","tabButton":"Tabs_tabButton__lcB5Z","activeTab":"Tabs_activeTab__7BK7U","tabContent":"Tabs_tabContent__BJVDS"};